import { render, staticRenderFns } from "./MunicipalityHome.vue?vue&type=template&id=02573287&scoped=true&"
import script from "./MunicipalityHome.vue?vue&type=script&lang=js&"
export * from "./MunicipalityHome.vue?vue&type=script&lang=js&"
import style0 from "./MunicipalityHome.vue?vue&type=style&index=0&id=02573287&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02573287",
  null
  
)

export default component.exports